import { render, staticRenderFns } from "./approvalRadio.vue?vue&type=template&id=5708ec3f&scoped=true&"
import script from "./approvalRadio.vue?vue&type=script&lang=js&"
export * from "./approvalRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708ec3f",
  null
  
)

export default component.exports